var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:arrow-up-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.18869 7.7925C2.00143 7.98 1.89624 8.23416 1.89624 8.49916C1.89624 8.76416 2.00143 9.01833 2.18869 9.20583L5.95936 12.9785C6.14696 13.1661 6.40139 13.2715 6.66669 13.2715C6.932 13.2715 7.18643 13.1661 7.37403 12.9785C7.56162 12.7909 7.66701 12.5365 7.66701 12.2712C7.66701 12.0059 7.56162 11.7514 7.37403 11.5638L5.31003 9.49916L13 9.49916C13.2652 9.49916 13.5196 9.39381 13.7071 9.20627C13.8947 9.01873 14 8.76438 14 8.49916C14 8.23395 13.8947 7.97959 13.7071 7.79206C13.5196 7.60452 13.2652 7.49916 13 7.49916L5.31003 7.49916L7.37403 5.43516C7.46692 5.34227 7.5406 5.232 7.59087 5.11064C7.64114 4.98927 7.66701 4.85919 7.66701 4.72783C7.66701 4.59647 7.64114 4.46639 7.59087 4.34502C7.5406 4.22366 7.46692 4.11338 7.37403 4.0205C7.28114 3.92761 7.17086 3.85393 7.0495 3.80366C6.92813 3.75338 6.79806 3.72751 6.66669 3.72751C6.53533 3.72751 6.40525 3.75338 6.28389 3.80366C6.16252 3.85393 6.05225 3.92761 5.95936 4.0205L2.18869 7.7925Z",
    fill: "#A76D6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.26593698592deb145aba563d964a4db2.svg";
export { ForwardRef as ReactComponent };